import { Component } from '@angular/core';
import{HeaderComponent}from '../app/header/header.component';
import{TimeRemainingComponent}from '../app/time-remaining/time-remaining.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'redact1';
  constructor(private translate: TranslateService) {
 
  }
}
